module.exports = __webpack_public_path__ + "static/media/hotpos.2eafbeeb.png";